<template>
    <section>
        <div class="flex items-center gap-2 flex-wrap">
            <el-button
                v-if="has_manager_ads"
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="handleRedirectToCreateCampaign()"
            >
                {{ $t('button.create') }}
            </el-button>

            <el-button
                size="small"
                class="!ml-0"
                @click="show_custom_column_dialog = true"
            >
                {{ $t('button.custom_column') }}
            </el-button>
            <div v-if="has_auto_ads">
                <el-dropdown trigger="click">
                    <el-button size="small">
                        {{ $t('common.automatic_rule') }}
                        <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <div
                                @click="
                                    is_create_automatic_rule_drawer_displayed = true
                                "
                            >
                                <p class="text-[0.8rem]">
                                    {{ $t('page.campaign.create_rule') }}
                                </p>
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div
                                @click="
                                    is_manage_automatic_rule_drawer_displayed = true
                                "
                            >
                                <p class="text-[0.8rem]">
                                    {{ $t('page.campaign.manage_rule') }}
                                </p>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div class="!ml-auto"></div>

            <div class="flex items-center">
                <el-switch
                    v-model="m__switch_auto_refresh"
                    @change="m__handleToggleAutoRefresh"
                ></el-switch>
                <p class="text-[0.75rem] mx-1">
                    {{ $t('page.campaign.auto_refresh') }}
                </p>
                <el-tooltip
                    effect="dark"
                    :content="$t('page.campaign.desc_auto_refresh')"
                    placement="top"
                >
                    <i class="el-icon-info text-desc-text"></i>
                </el-tooltip>
            </div>

            <el-select
                v-model="m__page_info.page_size"
                filterable
                class="w-[120px]"
                size="small"
                @change="
                    m__handleChangePagesize(m__getReportCampaignsByAccount)
                "
            >
                <el-option
                    v-for="item in m__list_pagesize"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>

            <el-input-number
                v-model="m__page_info.page"
                class="w-[120px]"
                size="small"
                :min="1"
                :max="m__page_info.total_page"
                @change="m__getReportCampaignsByAccount"
            ></el-input-number>

            <el-button
                icon="el-icon-refresh"
                size="small"
                @click="m__getReportCampaignsByAccount"
            ></el-button>
        </div>

        <div class="relative mt-4">
            <el-table
                ref="multipleTable"
                v-loading="m__loading"
                class="campaign-table"
                :show-summary="!name_filtering"
                max-height="560"
                :data="m__data_for_pagination"
                :summary-method="m__getSummaries"
                @selection-change="handleSelectionChange"
                @sort-change="m__handleSortChange"
            >
                <el-table-column type="selection" width="40" :fixed="true">
                </el-table-column>

                <el-table-column
                    :label="$t('table.header.on_off')"
                    :fixed="true"
                    width="60"
                >
                    <template #default="scope">
                        <el-switch
                            :value="scope.row.ad.operation_status === 'ENABLE'"
                            @change="handleChangeStatusAd(scope.row.ad.ad_id)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="300"
                    prop="ad.ad_name"
                    :label="$t('common.name')"
                    :fixed="true"
                >
                    <template #default="scope">
                        <div class="group hover:text-brand-atosa--light">
                            <div class="group flex items-center">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="scope.row.ad.ad_name"
                                    placement="top"
                                >
                                    <p class="truncate max-w-[240px]">
                                        {{ scope.row.ad.ad_name }}
                                    </p>
                                </el-tooltip>

                                <el-tooltip
                                    effect="dark"
                                    :content="$t('common.edit_name')"
                                    placement="top"
                                >
                                    <div
                                        v-if="
                                            [
                                                'AD_STATUS_CAMPAIGN_DELETE',
                                                'AD_STATUS_ADGROUP_DELETE',
                                                'AD_STATUS_DELETE'
                                            ].every(
                                                (item) =>
                                                    item !==
                                                    scope.row.ad
                                                        .secondary_status
                                            ) && has_manager_ads
                                        "
                                        class="ml-2 group-hover:block hidden cursor-pointer"
                                        @click="
                                            handleSelectRowToEditName(
                                                scope.row.ad
                                            )
                                        "
                                    >
                                        <i
                                            class="el-icon-edit text-[0.75rem] font-semibold"
                                        ></i>
                                    </div>
                                </el-tooltip>
                            </div>

                            <div
                                v-if="
                                    [
                                        'AD_STATUS_CAMPAIGN_DELETE',
                                        'AD_STATUS_ADGROUP_DELETE',
                                        'AD_STATUS_DELETE'
                                    ].every(
                                        (item) =>
                                            item !==
                                            scope.row.ad.secondary_status
                                    )
                                "
                                class="flex items-center mt-1 space-x-3"
                            >
                                <div
                                    v-if="has_report_ads"
                                    class="hover:underline flex items-center space-x-1 cursor-pointer"
                                    @click="handleOpenViewDataDrawer(scope.row)"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-chart-area"
                                    ></font-awesome-icon>
                                    <p>
                                        {{ $t('button.view_data') }}
                                    </p>
                                </div>

                                <div
                                    v-if="has_manager_ads"
                                    class="hover:underline flex items-center space-x-1 cursor-pointer"
                                    @click="handleOpenEditDrawer(scope.row)"
                                >
                                    <font-awesome-icon
                                        icon="fa-regular fa-pen-to-square"
                                    ></font-awesome-icon>
                                    <p>
                                        {{ $t('common.edit') }}
                                    </p>
                                </div>
                                <!-- <el-tooltip
                                v-if="
                                    ['DIRECT_LIVE', 'SHORT_VIDEO_LIVE'].some(
                                        (item) =>
                                            item === scope.row.ad.creative_type
                                    )
                                "
                                class="item"
                                effect="dark"
                                :content="
                                    $t(
                                        'page.campaign.message_live_ads_cant_duplicated'
                                    )
                                "
                                placement="top"
                            >
                                <div
                                    class="flex items-center space-x-1 opacity-40"
                                >
                                    <font-awesome-icon
                                        icon="fa-regular fa-copy"
                                    />
                                    <p>
                                        {{ $t('common.copy') }}
                                    </p>
                                </div>
                            </el-tooltip>

                            <div
                                v-else
                                class="flex items-center space-x-1 cursor-pointer hover:underline"
                                @click="handleOpenConfirmCopy(scope.row)"
                            >
                                <font-awesome-icon icon="fa-regular fa-copy" />
                                <p>
                                    {{ $t('common.copy') }}
                                </p>
                            </div> -->
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.status')" width="200px">
                    <template #default="scope">
                        <div class="flex items-center space-x-2">
                            <div
                                class="h-2 w-2 rounded-full"
                                :style="{
                                    background: [
                                        'AD_STATUS_PARTIAL_AUDIT_DELIVERY_OK',
                                        'AD_STATUS_DELIVERY_OK',
                                        'AD_STATUS_DONE'
                                    ].some(
                                        (item) =>
                                            item ===
                                            scope.row.ad.secondary_status
                                    )
                                        ? '#26cd26'
                                        : 'red'
                                }"
                            ></div>
                            <p class="font-medium">
                                {{
                                    renderLabelBySecondaryStatus(
                                        scope.row.ad.secondary_status
                                    )
                                }}
                            </p>
                        </div>
                        <el-tooltip
                            effect="dark"
                            :content="
                                renderDescriptionBySecondaryStatus(
                                    scope.row.ad.secondary_status
                                )
                            "
                            placement="top"
                        >
                            <p
                                class="text-desc-text text-[0.75rem] truncate w-[160px]"
                            >
                                {{
                                    renderDescriptionBySecondaryStatus(
                                        scope.row.ad.secondary_status
                                    )
                                }}
                            </p>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="160"
                    :show-overflow-tooltip="true"
                    prop="ad.adgroup_id"
                    :label="
                        $t('common.xxx_id', {
                            xxx: $t(`common.adgroup`)
                        })
                    "
                />

                <el-table-column
                    min-width="280"
                    prop="ad.adgroup_name"
                    :label="$t('table.header.ad_group_name')"
                >
                    <template #default="scope">
                        <div
                            class="group cursor-pointer"
                            @click="
                                handle_select_row(scope.row.ad.adgroup_id, true)
                            "
                        >
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="scope.row.ad.adgroup_name"
                                placement="top"
                            >
                                <p
                                    class="group-hover:underline truncate font-semibold text-brand-atosa--light"
                                >
                                    {{ scope.row.ad.adgroup_name }}
                                </p>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="160"
                    :show-overflow-tooltip="true"
                    prop="ad.ad_id"
                    label="ID"
                />

                <el-table-column
                    v-for="(item, index) in m__selected_columns"
                    :key="index"
                    :width="m__getContentWidthColumn(item)"
                    :show-overflow-tooltip="true"
                    :prop="item"
                    :label="$t(`page.campaign.column_${item}`)"
                    sortable="custom"
                    align="right"
                >
                    <template v-slot:header>
                        <el-tooltip
                            class="item"
                            :content="$t(`page.campaign.column_${item}`)"
                            effect="dark"
                            placement="top"
                        >
                            <div slot="content" class="max-w-[360px]">
                                <p
                                    class="text-[0.85rem]"
                                    v-html="$t(`page.campaign.column_${item}`)"
                                ></p>

                                <p
                                    v-if="
                                        $t(
                                            `page.campaign.description_column_${item}`
                                        ) !==
                                        `page.campaign.description_column_${item}`
                                    "
                                    class="mt-1"
                                    v-html="
                                        $t(
                                            `page.campaign.description_column_${item}`
                                        )
                                    "
                                ></p>
                            </div>
                            <p>
                                {{ $t(`page.campaign.column_${item}`) }}
                            </p>
                        </el-tooltip>
                    </template>

                    <template #default="scope">
                        <p>
                            {{
                                m__formatterColumn(
                                    scope.row[item],
                                    item,
                                    scope.row.currency
                                )
                            }}
                        </p>
                        <p v-if="scope.row.compare" class="text-desc-text">
                            {{
                                m__formatterColumn(
                                    scope.row.compare[item],
                                    item,
                                    scope.row.currency
                                )
                            }}
                        </p>
                    </template>
                </el-table-column>
            </el-table>

            <div
                v-if="!m__data_for_pagination.length"
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
                <div class="util-flex-center flex-col">
                    <img
                        class="w-[140px] h-[140px]"
                        :src="require('@/assets/images/no_data.png')"
                    />
                    <p class="mt-2 text-desc-text text-[0.9rem]">
                        {{ $t('common.no_data') }}
                    </p>
                </div>
            </div>
        </div>

        <EditDrawer
            :visible.sync="is_edit_drawer_displayed"
            :selected_item="active_item_for_edit"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :belong_to_atosa="belong_to_atosa"
            :bc_id="bc_id"
        ></EditDrawer>

        <CustomColumnDialog
            :column_values.sync="m__performance_column_values"
            :visible.sync="show_custom_column_dialog"
        ></CustomColumnDialog>

        <ViewDataDrawer
            :visible.sync="is_view_data_drawer_displayed"
            :selected_item="active_item_for_view_data"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :ranger_date="ranger_date"
            :belong_to_atosa="belong_to_atosa"
            type="ad_id"
        ></ViewDataDrawer>

        <CreateAutomaticRuleDrawer
            :visible.sync="is_create_automatic_rule_drawer_displayed"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :currency="currency"
            :multiple_selection="multiple_selection"
            type="AD"
        ></CreateAutomaticRuleDrawer>

        <ManageAutomaticRuleDrawer
            :visible.sync="is_manage_automatic_rule_drawer_displayed"
            :tiktok_account_id="tiktok_account_id"
            :advertiser_id="advertiser_id"
            :currency="currency"
        ></ManageAutomaticRuleDrawer>

        <ConfirmCopyDialog
            :visible.sync="is_confirm_copy_dialog_displayed"
            :handle_confirm_copy="handleConfirmCopy"
            :objective_type.sync="selected_copy_objective_type"
            :advertiser_id="advertiser_id"
            :tiktok_account_id="tiktok_account_id"
            :active_item_for_copy="active_item_for_copy"
        ></ConfirmCopyDialog>

        <el-dialog
            :visible.sync="visible_edit_name_dialog"
            width="400px"
            class="el-dialog-center"
            :show-close="false"
            :append-to-body="true"
            :close-on-click-modal="true"
        >
            <template slot="title">
                <p
                    class="text-left truncate w-4/5 text-[0.95rem] font-semibold"
                >
                    {{ `${$t('common.edit_name')}` }}
                </p>
                <p
                    v-if="selected_row_to_edit_name"
                    class="text-desc-text truncate w-4/5 text-[0.8rem]"
                >
                    #{{ selected_row_to_edit_name.campaign_id }}
                </p>
            </template>

            <div v-if="selected_row_to_edit_name">
                <el-input
                    v-model="selected_row_to_edit_name.ad_name"
                    size="small"
                    :placeholder="$t('input.placeholder.please_input')"
                ></el-input>
            </div>

            <template slot="footer">
                <div
                    v-if="selected_row_to_edit_name"
                    class="flex items-center justify-end"
                >
                    <el-button
                        size="small"
                        @click="visible_edit_name_dialog = false"
                    >
                        {{ $t('button.close') }}
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        :disabled="!selected_row_to_edit_name.ad_name"
                        @click="handleConfirmEditNameRow"
                    >
                        {{ $t('button.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </section>
</template>

<script>
import campaignMixin from '../_mixin'
import { updateAdStatus, updateAd } from '@/services/atosa-tiktok-ads/ad'
import CustomColumnDialog from '@/views/campaign/_components/custom-column-dialog'
import ConfirmCopyDialog from './confirm-copy-dialog'
import { removeEmptyParams } from '@/views/campaign/_utils'
import EditDrawer from './edit-drawer'
import ViewDataDrawer from '@/views/campaign/_components/view-data-drawer'
import CreateAutomaticRuleDrawer from '@/views/campaign/_components/atosa-create-automatic-rule-drawer'
import ManageAutomaticRuleDrawer from '@/views/campaign/_components/atosa-manage-automatic-rule-drawer'

export default {
    components: {
        ViewDataDrawer,
        EditDrawer,
        CustomColumnDialog,
        ManageAutomaticRuleDrawer,
        CreateAutomaticRuleDrawer,
        ConfirmCopyDialog
    },

    mixins: [campaignMixin],

    props: [
        'bc_id',
        'multiple_selection_adgroup',
        'multiple_selection_campaign'
    ],

    data() {
        return {
            is_manage_automatic_rule_drawer_displayed: false,
            is_create_automatic_rule_drawer_displayed: false,
            active_item_for_view_data: null,
            is_view_data_drawer_displayed: false,
            is_edit_drawer_displayed: false,
            active_item_for_edit: null,
            visible_edit_name_dialog: false,
            selected_row_to_edit_name: null,
            selected_copy_objective_type: '',
            list_adgroups: [],
            show_custom_column_dialog: false,
            is_confirm_copy_dialog_displayed: false,
            is_copy_drawer_displayed: false,
            active_item_for_copy: null
        }
    },

    computed: {
        multiple_selection_inline: {
            get() {
                return this.multiple_selection
            },
            set(value) {
                this.$emit('update:multiple_selection', value)
            }
        }
    },

    watch: {
        multiple_selection() {
            if (!this.multiple_selection_inline.length) {
                this.$refs.multipleTable.clearSelection([])
            }
        },

        multiple_selection_campaign() {
            const indexFilterById = this.m__filtering.findIndex(
                (item) => item.field_name === 'campaign_ids'
            )

            if (indexFilterById > -1) {
                this.m__filtering.splice(indexFilterById, 1)
            }

            if (this.multiple_selection_campaign.length) {
                const filter = {
                    filter_value: JSON.stringify(
                        this.multiple_selection_campaign.map((item) => item.id)
                    ),
                    field_name: 'campaign_ids',
                    filter_type: 'IN'
                }
                this.m__filtering.push(filter)
            }
            this.m__page_info.page = 1

            this.m__getReportCampaignsByAccount()
        },

        multiple_selection_adgroup() {
            const indexFilterById = this.m__filtering.findIndex(
                (item) => item.field_name === 'adgroup_ids'
            )

            if (indexFilterById > -1) {
                this.m__filtering.splice(indexFilterById, 1)
            }

            if (this.multiple_selection_adgroup.length) {
                const filter = {
                    filter_value: JSON.stringify(
                        this.multiple_selection_adgroup.map((item) => item.id)
                    ),
                    field_name: 'adgroup_ids',
                    filter_type: 'IN'
                }
                this.m__filtering.push(filter)
            }
            this.m__page_info.page = 1

            this.m__getReportCampaignsByAccount()
        }
    },

    mounted() {
        this.p__event_bus.$on(
            'eb_reload_ad',
            this.m__getReportCampaignsByAccount
        )

        this.m__type = 'ad_id'
        this.m__getReportCampaignsByAccount()

        const temp = localStorage.getItem(
            `performance_column_values_${this.m__type}`
        )
        if (temp && temp.length) {
            this.m__performance_column_values = JSON.parse(temp)
        } else {
            this.m__performance_column_values = [
                {
                    value: 'BASIC_DATA',
                    child_values: [
                        'spend',
                        'cpc',
                        'cpm',
                        'impressions',
                        'clicks',
                        'ctr',
                        'conversion',
                        'cost_per_conversion',
                        'conversion_rate'
                    ]
                }
            ]
        }
    },

    destroyed() {
        this.p__event_bus.$off(
            'eb_reload_ad',
            this.m__getReportCampaignsByAccount
        )
    },

    methods: {
        handleRedirectToCreateCampaign() {
            if (this.multiple_selection_adgroup.length === 1) {
                this.$router.push({
                    path: `${this.p__group_route.ads_manager}/${this.p__route.create_campaign}?adgroup_id=${this.multiple_selection_adgroup[0].adgroup.adgroup_id}`
                })
                return
            }

            if (
                this.multiple_selection_adgroup.length === 0 &&
                this.multiple_selection_campaign.length === 1
            ) {
                this.$router.push({
                    path: `${this.p__group_route.ads_manager}/${this.p__route.create_campaign}?campaign_id=${this.multiple_selection_campaign[0].campaign.campaign_id}`
                })
                return
            }

            this.$router.push({
                path: `${this.p__group_route.ads_manager}/${this.p__route.create_campaign}`
            })
        },

        handleOpenViewDataDrawer(row) {
            this.active_item_for_view_data = { ...row }
            this.is_view_data_drawer_displayed = true
        },

        renderLabelBySecondaryStatus(status) {
            if (!status) {
                return this.$t('common.not_delivering')
            }

            if (
                [
                    'AD_STATUS_PARTIAL_AUDIT_DELIVERY_OK',
                    'AD_STATUS_DELIVERY_OK'
                ].some((item) => item === status)
            ) {
                return this.$t('common.active')
            }

            if (
                [
                    'AD_STATUS_CAMPAIGN_DISABLE',
                    'AD_STATUS_ADGROUP_DISABLE',
                    'AD_STATUS_DISABLE'
                ].some((item) => item === status)
            ) {
                return this.$t('common.inactive')
            }

            if (
                [
                    'AD_STATUS_CAMPAIGN_DELETE',
                    'AD_STATUS_ADGROUP_DELETE',
                    'AD_STATUS_DELETE'
                ].some((item) => item === status)
            ) {
                return this.$t('common.deleted')
            }

            if (status === 'AD_STATUS_DONE') {
                return this.$t('common.completed')
            }

            if (status === 'AD_STATUS_RF_ADGROUP_CLOSED') {
                return this.$t('common.closed')
            }

            if (status === 'ADGROUP_STATUS_FROZEN') {
                return this.$t('common.frozen')
            }

            if (
                [
                    'AD_STATUS_ADVERTISER_AUDIT_DENY',
                    'AD_STATUS_ADVERTISER_AUDIT',
                    'ADVERTISER_CONTRACT_PENDING',
                    'ADVERTISER_ACCOUNT_PUNISH',
                    'AD_STATUS_LIVE_OFFLINE',
                    'AD_STATUS_BALANCE_EXCEED',
                    'AD_STATUS_ADGROUP_PARTIAL_AUDIT_NO_DELIVERY',
                    'AD_STATUS_PARTIAL_AUDIT_NO_DELIVERY',
                    'AD_STATUS_ADGROUP_AUDIT_DENY',
                    'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_MISSING',
                    'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_EXPIRED',
                    'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_DENY',
                    'AD_STATUS_MUSIC_AUTHORIZATION_MISSING',
                    'AD_STATUS_TRANSCODING_FAIL',
                    'AD_STATUS_AUDIT',
                    'AD_STATUS_REAUDIT',
                    'AD_STATUS_AUDIT_DENY',
                    'AD_STATUS_PROCESS_AUDIO',
                    'AD_STATUS_CAMPAIGN_EXCEED',
                    'AD_STATUS_BUDGET_EXCEED',
                    'AD_STATUS_NOT_START',
                    'AD_STATUS_ADGROUP_ASSET_AUTHORIZATION_LOST',
                    'AD_STATUS_ASSET_AUTHORIZATION_LOST',
                    'AD_STAUS_PIXEL_UNBIND'
                ].some((item) => item === status)
            ) {
                return this.$t('common.not_delivering')
            }

            return status
        },

        renderDescriptionBySecondaryStatus(status) {
            if (status === 'AD_STATUS_CAMPAIGN_DELETE') {
                return this.$t('page.campaign.adgroup_status_campaign_deleted')
            }
            if (status === 'AD_STATUS_ADGROUP_DELETE') {
                return this.$t('page.campaign.adgroup_status_adgroup_deleted')
            }
            if (status === 'AD_STATUS_DELETE') {
                return this.$t('page.campaign.ad_status_ad_deleted')
            }
            if (status === 'AD_STATUS_ADVERTISER_AUDIT_DENY') {
                return this.$t(
                    'page.campaign.campaign_status_account_not_approved'
                )
            }
            if (status === 'AD_STATUS_ADVERTISER_AUDIT') {
                return this.$t(
                    'page.campaign.campaign_status_account_in_review'
                )
            }
            if (status === 'ADVERTISER_CONTRACT_PENDING') {
                return this.$t(
                    'page.campaign.adgroup_status_contract_has_not_taken_effect'
                )
            }
            if (status === 'ADVERTISER_ACCOUNT_PUNISH') {
                return this.$t('page.campaign.adgroup_status_account_penalized')
            }
            if (status === 'AD_STATUS_BALANCE_EXCEED') {
                return this.$t(
                    'page.campaign.adgroup_status_payment_unsuccessful_or_insufficient_balance'
                )
            }
            if (status === 'AD_STATUS_ADGROUP_PARTIAL_AUDIT_NO_DELIVERY') {
                return this.$t('page.campaign.adgroup_status_in_review')
            }
            if (status === 'AD_STATUS_PARTIAL_AUDIT_NO_DELIVERY') {
                return this.$t('page.campaign.adgroup_status_in_review')
            }
            if (status === 'AD_STATUS_ADGROUP_AUDIT_DENY') {
                return this.$t('page.campaign.adgroup_status_not_approved')
            }
            if (status === 'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_MISSING') {
                return this.$t(
                    'page.campaign.adgroup_status_qualification_needed'
                )
            }
            if (status === 'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_EXPIRED') {
                return this.$t('page.campaign.adgroup_status_disapproved')
            }
            if (status === 'AD_STATUS_ADGROUP_INDUSTRY_QUALIFICATION_DENY') {
                return this.$t('page.campaign.adgroup_status_expired')
            }
            if (status === 'AD_STATUS_MUSIC_AUTHORIZATION_MISSING') {
                return this.$t(
                    'page.campaign.ad_status_music_copyright_missing'
                )
            }
            if (status === 'AD_STATUS_TRANSCODING_FAIL') {
                return this.$t(
                    'page.campaign.ad_status_replace_videos_with_errors_in_the_adgroup'
                )
            }
            if (status === 'AD_STATUS_AUDIT') {
                return this.$t('page.campaign.adgroup_status_in_review')
            }
            if (status === 'AD_STATUS_REAUDIT') {
                return this.$t('page.campaign.adgroup_status_edited_for_review')
            }
            if (status === 'AD_STATUS_AUDIT_DENY') {
                return this.$t('page.campaign.adgroup_status_not_approved')
            }
            if (status === 'AD_STATUS_PROCESS_AUDIO') {
                return this.$t(
                    'page.campaign.ad_status_processing_audio_reupload_if_it_gets_stuck'
                )
            }
            if (status === 'AD_STATUS_CAMPAIGN_EXCEED') {
                return this.$t(
                    'page.campaign.campaign_status_campaign_out_of_budget'
                )
            }
            if (status === 'AD_STATUS_BUDGET_EXCEED') {
                return this.$t(
                    'page.campaign.adgroup_status_ad_group_out_of_budget'
                )
            }
            if (status === 'AD_STATUS_NOT_START') {
                return this.$t(
                    'page.campaign.adgroup_status_outside_of_schedule'
                )
            }
            if (status === 'AD_STATUS_ADGROUP_ASSET_AUTHORIZATION_LOST') {
                return this.$t(
                    'page.campaign.adgroup_status_asset_unavailable_or_authorization_revoked'
                )
            }
            if (status === 'AD_STATUS_ASSET_AUTHORIZATION_LOST') {
                return this.$t(
                    'page.campaign.adgroup_status_asset_unavailable_or_authorization_revoked'
                )
            }
            if (status === 'AD_STAUS_PIXEL_UNBIND') {
                return this.$t(
                    'page.campaign.adgroup_status_pixel_unauthorized'
                )
            }
            if (status === 'AD_STATUS_CAMPAIGN_DISABLE') {
                return this.$t('page.campaign.adgroup_status_campaign_inactive')
            }
            if (status === 'AD_STATUS_ADGROUP_DISABLE') {
                return this.$t('page.campaign.adgroup_status_adgroup_inactive')
            }
            if (status === 'AD_STATUS_RF_ADGROUP_CLOSED') {
                return this.$t('page.campaign.ad_status_adgroup_is_closed')
            }

            if (status === 'AD_STATUS_DONE') {
                return ''
            }

            if (status === 'AD_STATUS_DELIVERY_OK') {
                return ''
            }

            if (status === 'ADGROUP_STATUS_FROZEN') {
                return this.$t('page.campaign.adgroup_status_frozen')
            }

            return status
        },

        handleOpenEditDrawer(row) {
            this.active_item_for_edit = { ...row }
            this.is_edit_drawer_displayed = true
        },

        handleSelectRowToEditName(row) {
            this.visible_edit_name_dialog = true
            this.selected_row_to_edit_name = { ...row }
        },

        async handleConfirmEditNameRow() {
            try {
                const creative = {
                    ...this.selected_row_to_edit_name,
                    ad_id: this.selected_row_to_edit_name.ad_id,
                    ad_name: this.selected_row_to_edit_name.ad_name,
                    belong_to_atosa: this.belong_to_atosa
                }

                removeEmptyParams(creative)

                await updateAd(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    adgroup_id: this.selected_row_to_edit_name.adgroup_id,
                    creatives: [creative]
                })

                this.m__getReportCampaignsByAccount()
                this.visible_edit_name_dialog = false

                this.p__showNotify(
                    'success',
                    this.$t('common.update_data_success')
                )
            } catch (error) {
                console.error(error)
            }
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row)
                })
            } else {
                this.$refs.multipleTable.clearSelection()
            }
        },

        handleSelectionChange(val) {
            this.multiple_selection_inline = val
        },

        async handleChangeStatusAd(ad_id) {
            const ad = this.m__data_for_pagination.find(
                (item) => item.ad.ad_id === ad_id
            )

            if (!ad) {
                return
            }

            ad.ad.operation_status =
                ad.ad.operation_status === 'ENABLE' ? 'DISABLE' : 'ENABLE'
            try {
                await updateAdStatus(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    ad_ids: [ad_id],
                    belong_to_atosa: this.belong_to_atosa,
                    operation_status: ad.ad.operation_status
                })

                this.m__getReportCampaignsByAccount()

                this.p__showNotify(
                    'success',
                    this.$t('page.campaign.message_update_status_xxx_success', {
                        xxx: this.$t(`common.ad`)
                    })
                )
            } catch (error) {
                console.error(error)

                ad.ad.operation_status =
                    ad.ad.operation_status === 'ENABLE' ? 'DISABLE' : 'ENABLE'

                this.p__showNotify(
                    'error',
                    this.$t('page.campaign.message_update_status_xxx_failed', {
                        xxx: this.$t(`common.ad`)
                    })
                )
            }
        },

        handleOpenConfirmCopy(data) {
            this.active_item_for_copy = data.ad

            this.is_confirm_copy_dialog_displayed = true
        },

        handleConfirmCopy(list_adgroups) {
            this.list_adgroups = list_adgroups

            this.is_copy_drawer_displayed = true
        }
    }
}
</script>
